export default {
  created() {
    this.getCitiesInfo()
  },
  data(){
    return {
      citiesInfo: []
    }
  },
  methods: {
    // 获取city
    getCitiesInfo() {
      this.fetch.get('srm_getCitiesInfo').then(res => {
        const data = res.data || {}
        if (data.citiesInfo && data.citiesInfo.length > 0) {
          this.citiesInfo = data.citiesInfo.map(el => {
            return {
              label: el.cityDisplayedName,
              value: el.cityCode
            }
          })
        }
      })
    },
  }
}
